import type { RouteObject } from "react-router-dom";

import { marketRoutes } from "./marketplace/routes";

export const exchangeRoutes: Array<RouteObject> = [...marketRoutes];
